/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaArrowRightAlt/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaArrowRightAlt({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaArrowRightAlt",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaArrowRightAlt.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-131Ku7': alignSelf,'--mt-2-131Ku7': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-131Ku7': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-131Ku7': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-131Ku7': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-131Ku7': opacity,'--w-10-131Ku7': typeof width === 'number' ? `${width}px` : width,'--h-11-131Ku7': typeof height === 'number' ? `${height}px` : height,'--f-12-131Ku7': fill,'--a-7-131Ku7': isAnimated ? animation : "none",'--sd-8-131Ku7': isAnimated ? strokeDashoffset : 0,'--sd-9-131Ku7': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaArrowRightAlt.SvgPath"
  data-view-path={viewPath}
 d="M14.025 17.95L12.95 16.9l4.2-4.2H4v-1.5h13.15l-4.225-4.225L14 5.925l6.025 6.025-6 6z"
 style={{'--f-12-131Ku7': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}